export default "__VITE_ASSET__59ebef12__"